module.exports = __webpack_public_path__ + "img/2-4.68a369bc.svg";